// extracted by mini-css-extract-plugin
export default {"docu-sign-modal":"docuSign_docu-sign-modal__Syx6L","docusign-agreement-container":"docuSign_docusign-agreement-container__ZWp-a"};